const FEATURE_TOGGLES = {
    SLOT_LOGGING: false,
    SCALES_INTEGRATION: true,
    ITSME: true,
};

export default FEATURE_TOGGLES;
